import {CustomerResponseBodyV2} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getSupplierById = (
  customersAsSuppliers: CustomerResponseBodyV2[],
  supplierId: string | Nullish
) => customersAsSuppliers.find((customersAsSupplier) => customersAsSupplier.id === supplierId);
